import React, {useContext, useEffect, useState} from 'react'

import Loader from '../Loader/Loader'
import { firestore } from '../../firebase'
import PostTemplate from '../Post/PostComponents/PostTemplate';
import StateContext from '../../StateContext';

function BlogPosts(props) {


    const appState = useContext(StateContext)

    const [activeItem, setActiveItem] = useState("1")
    const [posts, setPosts] = useState([]);

    const [followedAuthors, setFollowedAuthors] = useState([])
    const [postsByFollowedAuthors, setPostsByFollowedAuthors] = useState([])
    const [isLoading, setIsloading] = useState(true);


    useEffect(() => {

        // Finne fulgte forfattere
        if (appState.loggedIn) {
            console.log("follow ran")
            try {
                const followRef = firestore.collection("follow");
                followRef.where("follower_id", "==", appState.userId).onSnapshot(({docs}) => {
                    const followers = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    //console.log(followers, "Followers with logged in user id")
                    const followingIds = followers.map(follower => {
                        return follower.followed_id
                    })
                    console.log(followingIds, "followed author ids")
                    if (followers) {
                        setFollowedAuthors(followingIds)
                    }
                })
            } catch (error) {
                console.log(error)
            }
        }


    }, [appState.loggedIn])

    useEffect(() => {
        async function getBlogPosts() {

            try {
                //console.log(page)
                setIsloading(true)
                const postsRef = firestore.collection("recipes")

                postsRef.onSnapshot(({docs}) => {
                    const posts = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setPosts(posts)
                })

            } catch (error) {

            }
            setIsloading(false)

        }
        getBlogPosts()
    }, [followedAuthors])

    useEffect(() => {

        if (posts && followedAuthors) {
            const postsByFollowedAuthors = posts.filter(post => {
                
                //console.log(post.author_id, "===", followedAuthors, "post is by author who current logged in user follows")
                return followedAuthors.includes(post.author_id);
            })
            console.log(postsByFollowedAuthors, "posts by followed authors ran")
            setPostsByFollowedAuthors(postsByFollowedAuthors)
        }

    }, [posts, followedAuthors])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    if (isLoading) return (

        <div>
            <Loader />
        </div>

    )

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <button onClick={() => toggle("1")} className={activeItem === "1" ? "btn btn-sm btn-success btn-block active" : "btn btn-sm btn-success btn-block"}>Oppskrifter fra forfattere du følger</button>
                </div>
                <div className="col-6">
                    <button onClick={() => toggle("2")} className={activeItem === "2" ? "btn btn-sm btn-success btn-block active" : "btn btn-sm btn-success btn-block"}>Alle oppskrifter</button>
                </div>
            </div>

            {activeItem === "1" && (
                <div className="row">
                    {postsByFollowedAuthors && postsByFollowedAuthors.map(post => {

                        const string = post.title;
                        const stringLength = string.length
                        const length = 27;
                        let formattedTitle, trimmedTitle
                        if (stringLength > length) {
                            trimmedTitle = string.substring(0, length) 
                            formattedTitle = trimmedTitle + "..."
                        } else {
                            formattedTitle = post.title
                        }

                        const date = post.date.toDate()
                        const dateFormatted = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;

                        return (
                            <PostTemplate
                                key={post.id}
                                title={formattedTitle}
                                author={post.author_name}
                                postId={post.id}
                                dateFormatted={dateFormatted}
                                imageUrl={post.imageUrl}
                            />
                            
                        )
                        
                    })}
                </div>
            )}

            {activeItem === "2" && (
                <div className="row">
                    {posts.map(post => {

                        const string = post.title;
                        const stringLength = string.length
                        const length = 27;
                        let formattedTitle, trimmedTitle
                        if (stringLength > length) {
                            trimmedTitle = string.substring(0, length) 
                            formattedTitle = trimmedTitle + "..."
                        } else {
                            formattedTitle = post.title
                        }
                        
                        const date = post.date.toDate()
                        const dateFormatted = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;

                        return (
                            <PostTemplate
                                key={post.id}
                                title={formattedTitle}
                                author={post.author_name}
                                postId={post.id}
                                dateFormatted={dateFormatted}
                                imageUrl={post.imageUrl}
                            />
                            
                        )
                        
                    })}
                </div>
            )}

        </>
    )
    

}
export default BlogPosts